/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WorkloadsEvents;
    (function (WorkloadsEvents) {
        WorkloadsEvents.DeploymentsFetchedEvent = "DEPLOYMENTS_FETCHED_EVENT";
        WorkloadsEvents.ReplicaSetsFetchedEvent = "REPLICA_SETS_FETCHED_EVENT";
        WorkloadsEvents.DaemonSetsFetchedEvent = "DAEMON_SETS_FETCHED_EVENT";
        WorkloadsEvents.StatefulSetsFetchedEvent = "STATEFUL_SETS_FETCHED_EVENT";
        WorkloadsEvents.WorkloadPodsFetchedEvent = "WORKLOAD_PODS_FETCHED_EVENT";
        WorkloadsEvents.WorkloadsFoundEvent = "NON_ZERO_WORKLOADS_FOUND_EVENT";
        WorkloadsEvents.ZeroDeploymentsFoundEvent = "ZERO_DEPLOYMENTS_FOUND_EVENT";
    })(WorkloadsEvents = exports.WorkloadsEvents || (exports.WorkloadsEvents = {}));
    var ServicesEvents;
    (function (ServicesEvents) {
        ServicesEvents.ServicesFetchedEvent = "SERVICES_FETCHED_EVENT";
        ServicesEvents.ServicePodsFetchedEvent = "SERVICE_PODS_FETCHED_EVENT";
        ServicesEvents.ServicesFoundEvent = "NON_ZERO_SERVICES_FOUND_EVENT";
    })(ServicesEvents = exports.ServicesEvents || (exports.ServicesEvents = {}));
    var PodsEvents;
    (function (PodsEvents) {
        PodsEvents.PodsFetchedEvent = "ALL_PODS_FETCHED_EVENT";
        PodsEvents.LabelledPodsFetchedEvent = "LABELLED_PODS_FETCHED_EVENT";
    })(PodsEvents = exports.PodsEvents || (exports.PodsEvents = {}));
    var ImageDetailsEvents;
    (function (ImageDetailsEvents) {
        ImageDetailsEvents.HasImageDetailsEvent = "HAS_IMAGE_DETAILS_EVENT";
        ImageDetailsEvents.SetImageDetailsEvent = "SET_IMAGE_DETAILS_EVENT";
    })(ImageDetailsEvents = exports.ImageDetailsEvents || (exports.ImageDetailsEvents = {}));
    var HyperLinks;
    (function (HyperLinks) {
        HyperLinks.WorkloadsLink = "https://go.microsoft.com/fwlink/?linkid=2083857";
        HyperLinks.LinkToPodsUsingLabelsLink = "https://kubernetes.io/docs/concepts/overview/working-with-objects/labels/";
        HyperLinks.ServicesLink = "https://go.microsoft.com/fwlink/?linkid=2083858";
        HyperLinks.ResourceDeletedLink = "https://go.microsoft.com/fwlink/?linkid=2083857";
        HyperLinks.ResourceAccessDeniedLink = "https://go.microsoft.com/fwlink/?linkid=2083857";
    })(HyperLinks = exports.HyperLinks || (exports.HyperLinks = {}));
    var Scenarios;
    (function (Scenarios) {
        Scenarios.Services = "KubeSummary.ServicesList";
        Scenarios.PodsList = "KubeSummary.PodsList";
        Scenarios.ImageDetails = "KubeSummary.ImageDetails";
        Scenarios.PodsDetails = "KubeSummary.PodsDetails";
        Scenarios.ServiceDetails = "KubeSummary.ServiceDetails";
        Scenarios.PodOverview = "KubeSummary.PodOverview";
        Scenarios.PodLogs = "KubeSummary.PodLogs";
        Scenarios.PodYaml = "KubeSummary.PodYaml";
        Scenarios.WorkloadDetails = "KubeSummary.WorkloadDetails";
        Scenarios.Workloads = "KubeSummary.Workloads";
    })(Scenarios = exports.Scenarios || (exports.Scenarios = {}));
});
